import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import { Link } from "routes";
import Typography from '@material-ui/core/Typography';

const styles = theme => ({ 
    tagStyle: { 
        color: '#306ca0', 
        fontSize: 14, 
        overflowWrap: 'break-word',
        paddingTop: 14
      }
})

class VideoDetailTags extends Component {
  render() {
    const { classes, tagChips, routeName } = this.props;
    return (
        tagChips.length != 0 ?
            <div>
                {
                   tagChips.map((tag,i) =>{
                    const slug = tag.slug
                    const newString = slug.replace(/_|-/g, " ")
                        .replace(/([A-Z])/g, ' $1').trim();
                    const fontConvertString = fontUniOrConvertZawgyi(newString);
                    return(
                        <Link key={i} route={routeName} params={{ tag: tag.slug }}>
                            <a className="anchor-link">
                                <Typography component="p" variant="subtitle1" className={classes.tagStyle}>
                                    #{fontConvertString}
                                </Typography>
                            </a>
                        </Link>
                    )
                    })
                }
            </div>
        : null
    );
  }
}

export default withStyles(styles)(VideoDetailTags);
